import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import PublicFooter from '../components/PublicFooter';

const DataDeletion = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="border-b">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="flex items-center space-x-2">
            <MessageSquare className="h-8 w-8 text-blue-600" />
            <span className="text-2xl font-bold text-gray-900">ChatFlow</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">User Data Deletion — ChatFlow</h1>
          <p className="text-gray-500 mb-8">Last updated: 2026-02-02</p>

          <div className="prose prose-gray max-w-none">
            <p className="text-lg text-gray-700 mb-8">
              If you want to delete your ChatFlow account and associated personal data, you can request deletion at any time.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">How to request deletion</h2>
            <ol className="list-decimal pl-6 text-gray-700 space-y-3 mb-6">
              <li>
                Email <a href="mailto:contact@chatflow.info" className="text-blue-600 hover:underline">contact@chatflow.info</a> with the subject line: <strong>"Data Deletion Request — ChatFlow"</strong>
              </li>
              <li>
                In the email, include:
                <ul className="list-disc pl-6 mt-2 space-y-2">
                  <li>The email address used for your ChatFlow account</li>
                  <li>Your full name (as shown in your account), if available</li>
                  <li>If you used a third-party login/integration (e.g., Facebook/Instagram), include the relevant account/page identifier if known (optional)</li>
                </ul>
              </li>
              <li>
                We may ask for additional information to verify identity and prevent unauthorized deletion requests.
              </li>
            </ol>

            <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">What we delete</h2>
            <p className="text-gray-700 mb-6">
              After verification, we will delete or anonymize personal data associated with your account, unless we must retain certain information to comply with legal obligations (e.g., billing/financial records) or to prevent fraud and abuse.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">Timeframe</h2>
            <p className="text-gray-700 mb-6">
              We typically complete deletion requests within 30 days.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">Questions</h2>
            <p className="text-gray-700 mb-6">
              If you have any questions about deletion, contact <a href="mailto:contact@chatflow.info" className="text-blue-600 hover:underline">contact@chatflow.info</a>.
            </p>
          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
};

export default DataDeletion;
